"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Loader = exports.WithLoader = void 0;
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var load_1 = require("../../../data/load");
var ui_1 = require("./ui");
exports.WithLoader = function (_a) {
    var dataLoad = _a.dataLoad, updatePromise = _a.updatePromise;
    return (react_1["default"].createElement(load_1.WithLoader, { Component: ui_1.UI, dataLoad: dataLoad, updatePromise: updatePromise }));
};
exports.Loader = function (_a) {
    var isLoading = _a.isLoading;
    if (isLoading !== true) {
        return null;
    }
    return (react_1["default"].createElement(Typography_1["default"], null,
        react_1["default"].createElement("i", null, "The status is being updated, please wait")));
};
